import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Plano} from "../models/plano";
import {PlanoAcaoEstrategica} from "../models/plano-acao-estrategica";
import {PlanoAvaliacao} from "../models/plano-avaliacao";
import {PlanoMeta} from "../models/plano-meta";
import {PlanoObjetivo} from "../models/plano-objetivo";
import {PlanoOutraDefinicao} from "../models/plano-outra-definicao";
import {PlanoDiagnostico} from "../models/plano-diagnostico";
import {PlanoAvaliacaoOutro} from "../models/plano-avaliacao-outro";
import {PlanoObjetivoOutro} from "../models/plano-objetivo-outro";
import {PlanoMetaOutro} from "../models/plano-meta-outro";
import {PlanoAcaoEstrategicaOutro} from "../models/plano-acao-estrategica-outro";
import {PlanoOutraDefinicaoOutro} from "../models/plano-outra-definicao-outro";
import {saveAs} from "file-saver";
import get = Reflect.get;
import {Usuario} from "../models/usuario";
import {Perfil} from "../models/perfil";

@Injectable({
    providedIn: 'root'
})
export class PlanoService {

    private api_url = environment.api_url + "/plano";

    constructor(private http: HttpClient) {

    }

    listAll(estado: string = null, municipio: number = null, usuario: number = null, situacao_plano: string = null, com_usuario: boolean = false): Observable<Plano[]> {
        let url: string = this.api_url;
        url += (estado) ? ('/' + estado) : ('/0');
        url += (municipio) ? ('/' + municipio) : ('/0');
        url += (usuario) ? ('/' + usuario) : ('/0');
        url += (situacao_plano) ? ('/' + situacao_plano) : ('/0');
        url += "?include=municipio";
        if (com_usuario) {
            url += ",usuario";
        }
        return this.http.get(url).pipe(map((res: any) => {
            return res.data as Array<Plano>;
        }));
    }


    findById(id: number, completo: boolean = false): Observable<Plano> {
        let url: string = this.api_url + "/show/" + id;
        url += "?include=municipio";
        if (completo) {
            url += ",objetivos,metas,acoes_estrategicas,diagnosticos,avaliacoes,outras_definicoes";
        }
        return this.http.get(url).pipe(map((res: any) => {
            let plano: Plano = res as Plano;
            if (res.diagnosticos) {
                plano.diagnosticos = res.diagnosticos.data as Array<PlanoDiagnostico>;
            }
            if (res.acoes_estrategicas) {
                let acoes_estrategicas: Array<PlanoAcaoEstrategica> = [];
                if (res.acoes_estrategicas && res.acoes_estrategicas.data.length > 0) {
                    res.acoes_estrategicas.data.forEach((obj_plano_acao_estrategica: any) => {
                        let outros: Array<PlanoAcaoEstrategicaOutro> = [];
                        if (obj_plano_acao_estrategica.outros && obj_plano_acao_estrategica.outros.data.length > 0) {
                            outros = obj_plano_acao_estrategica.outros.data as Array<PlanoAcaoEstrategicaOutro>;
                        }
                        let plano_acao_estrategica: PlanoAcaoEstrategica = obj_plano_acao_estrategica as PlanoAcaoEstrategica;
                        plano_acao_estrategica.outros = outros;
                        acoes_estrategicas.push(plano_acao_estrategica);
                    });
                }
                plano.acoes_estrategicas = acoes_estrategicas;
            }
            if (res.avaliacoes) {
                let avaliacoes: Array<PlanoAvaliacao> = [];
                if (res.avaliacoes && res.avaliacoes.data.length > 0) {
                    res.avaliacoes.data.forEach((obj_plano_avaliacao: any) => {
                        let outros: Array<PlanoAvaliacaoOutro> = [];
                        if (obj_plano_avaliacao.outros && obj_plano_avaliacao.outros.data.length > 0) {
                            outros = obj_plano_avaliacao.outros.data as Array<PlanoAvaliacaoOutro>;
                        }
                        let plano_avaliacao: PlanoAvaliacao = obj_plano_avaliacao as PlanoAvaliacao;
                        plano_avaliacao.outros = outros;
                        avaliacoes.push(plano_avaliacao);
                    });
                }
                plano.avaliacoes = avaliacoes;
            }
            if (res.metas) {
                let metas: Array<PlanoMeta> = [];
                if (res.metas && res.metas.data.length > 0) {
                    res.metas.data.forEach((obj_plano_meta: any) => {
                        let outros: Array<PlanoMetaOutro> = [];
                        if (obj_plano_meta.outros && obj_plano_meta.outros.data.length > 0) {
                            outros = obj_plano_meta.outros.data as Array<PlanoMetaOutro>;
                        }
                        let plano_meta: PlanoMeta = obj_plano_meta as PlanoMeta;
                        plano_meta.outros = outros;
                        metas.push(plano_meta);
                    });
                }
                plano.metas = metas;
            }
            if (res.objetivos) {
                let objetivos: Array<PlanoObjetivo> = [];
                if (res.objetivos && res.objetivos.data.length > 0) {
                    res.objetivos.data.forEach((obj_plano_objetivo: any) => {
                        let outros: Array<PlanoObjetivoOutro> = [];
                        if (obj_plano_objetivo.outros && obj_plano_objetivo.outros.data.length > 0) {
                            outros = obj_plano_objetivo.outros.data as Array<PlanoObjetivoOutro>;
                        }
                        let plano_objetivo: PlanoObjetivo = obj_plano_objetivo as PlanoObjetivo;
                        plano_objetivo.outros = outros;
                        objetivos.push(plano_objetivo);
                    });
                }
                plano.objetivos = objetivos;
            }
            if (res.outras_definicoes) {
                let outras_definicoes: Array<PlanoOutraDefinicao> = [];
                if (res.outras_definicoes && res.outras_definicoes.data.length > 0) {
                    res.outras_definicoes.data.forEach((obj_plano_outra_definicao: any) => {
                        let outros: Array<PlanoOutraDefinicaoOutro> = [];
                        if (obj_plano_outra_definicao.outros && obj_plano_outra_definicao.outros.data.length > 0) {
                            outros = obj_plano_outra_definicao.outros.data as Array<PlanoOutraDefinicaoOutro>;
                        }
                        let plano_outra_definicao: PlanoOutraDefinicao = obj_plano_outra_definicao as PlanoOutraDefinicao;
                        plano_outra_definicao.outros = outros;
                        outras_definicoes.push(plano_outra_definicao);
                    });
                }
                plano.outras_definicoes = outras_definicoes;
            }
            return plano;
        }));
    }

    save(form: Plano): Observable<any> {
        let url: string = this.api_url;
        let http;
        if (form.cod_plano) {
            http = this.http.put(url + "/" + form.cod_plano, form);
        } else {
            http = this.http.post(url, form);
        }
        return http.pipe(map((res: any) => {
            return res;
        }));
    }

    updateSituacao(cod_plano: number, sgl_situacao_plano: string): Observable<any> {
        let url: string = this.api_url;
        let http;
        http = this.http.put(url + "/situacao/" + cod_plano + "/" + sgl_situacao_plano, {});
        return http.pipe(map((res: any) => {
            return res.data;
        }));
    }

    updateUsuario(cod_plano: number, cod_usuario: number): Observable<any> {
        let url: string = this.api_url;
        let http;
        http = this.http.put(url + "/usuario/" + cod_plano + "/" + cod_usuario, {});
        return http.pipe(map((res: any) => {
            return res;
        }));
    }

    exportExcel(uf: string = null, municipio: number = null, usuario: number = null, situacao_plano: string = null): void {
        let url: string = this.api_url + "/excel";
        url += (uf) ? ('/' + uf) : ('/0');
        url += (municipio) ? ('/' + municipio) : ('/0');
        url += (usuario) ? ('/' + usuario) : ('/0');
        url += (situacao_plano) ? ('/' + situacao_plano) : ('/0');
        window.open(url, "_blank");
    }

    exportPdf(cod_plano: number): void {
        let url: string = this.api_url + "/pdf/" + cod_plano;
        window.open(url, '_blank');
    }

    exportWord(cod_plano: number): void {
        let url: string = this.api_url + "/word/" + cod_plano;
        this.http.get(url, {responseType: 'text'})
            .subscribe(html => {
                var blob = new Blob([html], {
                    // type: 'application/octet-binary',
                    type: 'text/html'
                });
                saveAs(blob, 'plano_mobilidade.doc');
            })
    }

    uploadFile(formData): Observable<any> {
        let url: string = this.api_url + "/upload";
        return this.http.post(url, formData);
    }
}
